import { DOCUMENT } from "@angular/common";
import { Injectable, inject } from "@angular/core";

export interface TurnstileRenderOptions {
  sitekey: string;
  action?: string;
  appearance?: "always" | "execute" | "interaction-only";
  // "flexible" fills the container's width (minimum 300px)
  size?: "normal" | "compact" | "flexible";
  callback?: (token: string) => void;
  "expired-callback"?: () => void;
  "error-callback"?: (code: string) => boolean | void;
}

export interface TurnstileApi {
  render(container: HTMLElement, options: TurnstileRenderOptions): string;
  reset(widgetId: string): void;
  remove(widgetId: string): void;
}

const SCRIPT_URL = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";

/** Loads Cloudflare Turnstile once and hands out its API. */
@Injectable({ providedIn: "root" })
export class TurnstileService {
  private readonly document = inject(DOCUMENT);
  private api?: Promise<TurnstileApi>;

  load(): Promise<TurnstileApi> {
    this.api ??= new Promise<TurnstileApi>((resolve, reject) => {
      const existing = (window as any).turnstile as TurnstileApi | undefined;
      if (existing) {
        resolve(existing);
        return;
      }
      const script = this.document.createElement("script");
      script.src = SCRIPT_URL;
      script.async = true;
      script.onload = () => resolve((window as any).turnstile);
      script.onerror = () => {
        this.api = undefined;
        reject(new Error("Could not load Cloudflare Turnstile"));
      };
      this.document.head.appendChild(script);
    });
    return this.api;
  }
}
